import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TabViewModule } from 'primeng/tabview';
import { SeguimientoComponent } from './seguimiento/seguimiento.component';
import { SolicitudHistorialComponent } from './solicitud-historial/solicitud-historial.component';
import { ActivatedRoute } from '@angular/router';
import { CuidadanoComponent } from './cuidadano/cuidadano.component';
import { CustomTitle } from 'lib-base';

@Component({
  selector: 'app-pqrsd-actividad-seguimiento',
  standalone: true,
  imports: [TabViewModule, TranslateModule, CommonModule, SeguimientoComponent, SolicitudHistorialComponent, CuidadanoComponent],
  templateUrl: './pqrsd-actividad-seguimiento.component.html',
  styleUrl: './pqrsd-actividad-seguimiento.component.scss'
})
export class PqrsdActividadSeguimientoComponent implements AfterViewInit{
  title: string ='';
  activeTabIndex: number = 0;

  actividadId !: number;
  solicitudId !: number;
  
  @ViewChild(SeguimientoComponent) actividadComponent !: SeguimientoComponent;
  @ViewChild(SolicitudHistorialComponent) TramiteHistorialComponent !: SolicitudHistorialComponent;
  @ViewChild(CuidadanoComponent) CuidadanoComponent !: CuidadanoComponent;

  constructor(private readonly _route: ActivatedRoute) {
    this.actividadId = Number(this._route.snapshot.params['actividadId']);    
    this.solicitudId = Number(this._route.snapshot.params['solicitudId']);
  }

  ngAfterViewInit(): void {
    this.activeIndexChange(0);
  }
  
  activeIndexChange(index: number) {
    if (index === 0)
      this.actividadComponent.getActividadInfo();
    else if( index === 1)
      this.CuidadanoComponent.getInformacionCiudadano();
    else if( index === 2)
      this.TramiteHistorialComponent.getHistorial();
  }
}
